/**
 * Async bootstrap entry point required by Module Federation.
 * The dynamic import gives the MF runtime an async tick to negotiate shared
 * modules (e.g. react, react-dom) before any app code runs, preventing the
 * "loadShareSync called before share init is complete" error.
 *
 * We import `./bootstrap` (which performs the `createRoot().render()` DOM
 * mount) rather than `./App`, so `src/App.tsx` stays a pure component module
 * and remains a valid React Fast Refresh boundary (fixing live reload).
 */
import('./bootstrap');
